/**
 * CELLHACK product page sections (everything after product-main):
 * FAQ accordion (single-open), reviews filter chips + load more, and the
 * cosmetic "Request your batch CoA" form optimistic state. Loaded once
 * (from sections/product-ingredients.liquid) and scoped by data attributes
 * / container classes so it only touches markup these sections render.
 * Add-to-cart buttons on this page (`data-ch-add`) are handled generically
 * by assets/cellhack-cart.js — nothing to do here for those.
 */
(function () {
  // FAQ accordion (single-open) ---------------------------------------------
  var faqItems = Array.prototype.slice.call(document.querySelectorAll('[data-ch-faq-item]'));
  faqItems.forEach(function (item) {
    var trigger = item.querySelector('[data-ch-faq-trigger]');
    var panel = item.querySelector('[data-ch-faq-panel]');
    var icon = item.querySelector('[data-ch-faq-icon]');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function () {
      var isOpen = !panel.hidden;
      faqItems.forEach(function (other) {
        var otherPanel = other.querySelector('[data-ch-faq-panel]');
        var otherTrigger = other.querySelector('[data-ch-faq-trigger]');
        var otherIcon = other.querySelector('[data-ch-faq-icon]');
        if (otherPanel) otherPanel.hidden = true;
        if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        if (otherIcon) otherIcon.textContent = '+';
      });
      if (!isOpen) {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        if (icon) icon.textContent = '−';
      }
    });
  });

  // Reviews: filter chips + load more ---------------------------------------
  var reviewsSection = document.querySelector('.ch-reviews');
  if (reviewsSection) {
    var filterButtons = Array.prototype.slice.call(reviewsSection.querySelectorAll('[data-ch-review-filter]'));
    var cards = Array.prototype.slice.call(reviewsSection.querySelectorAll('[data-ch-review-card]'));
    var emptyMessage = reviewsSection.querySelector('[data-ch-review-empty]');
    var moreButton = reviewsSection.querySelector('[data-ch-review-more]');
    var currentFilter = 'all';
    var expanded = false;

    function matchesFilter(card, filter) {
      if (filter === 'all') return true;
      if (filter === 'photo') return card.getAttribute('data-photo') === 'true';
      if (filter === '5') return card.getAttribute('data-rating') === '5';
      if (filter === '4') return card.getAttribute('data-rating') === '4';
      if (filter === 'bundle') return card.getAttribute('data-bundle') === 'true';
      return true;
    }

    function render() {
      var visibleCount = 0;
      cards.forEach(function (card) {
        var isMatch = matchesFilter(card, currentFilter);
        var isExtra = card.classList.contains('is-extra');
        var shouldShow = isMatch && (currentFilter !== 'all' || expanded || !isExtra);
        card.hidden = !shouldShow;
        if (shouldShow) visibleCount += 1;
      });
      if (emptyMessage) emptyMessage.hidden = visibleCount !== 0;
      if (moreButton) moreButton.hidden = currentFilter !== 'all' || expanded;
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        currentFilter = button.getAttribute('data-ch-review-filter');
        filterButtons.forEach(function (other) {
          other.classList.toggle('is-active', other === button);
        });
        render();
      });
    });

    if (moreButton) {
      moreButton.addEventListener('click', function () {
        expanded = true;
        render();
      });
    }

    render();
  }

  // Supplement facts: "Request your batch CoA" form -------------------------
  // Cosmetic only — no backend endpoint exists in the design prototype, so
  // this just shows an optimistic success state client-side.
  var coaForm = document.querySelector('[data-ch-coa-form]');
  if (coaForm) {
    coaForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var submitButton = coaForm.querySelector('[data-ch-coa-submit]');
      var label = coaForm.querySelector('[data-ch-coa-label]');
      if (label) label.textContent = 'Requested ✓';
      if (submitButton) submitButton.setAttribute('aria-disabled', 'true');
    });
  }

  // Write a review panel -------------------------------------------------------
  var openBtn = document.querySelector('[data-ch-review-open]');
  var panel = document.querySelector('[data-ch-review-panel]');
  if (openBtn && panel) {
    var sync = function () { openBtn.setAttribute('aria-expanded', String(!panel.hidden)); };
    openBtn.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
      sync();
      if (!panel.hidden) {
        var first = panel.querySelector('input:not([type=hidden]), textarea');
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        if (first && first.type !== 'radio') first.focus({ preventScroll: true });
      }
    });
    sync();
  }
})();
